import React, {useContext, useState} from 'react'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import config from "../config.json"
import {useHttp} from "../hooks/http.hook"
import {ViewResultsSearchClass} from "../components/ViewResultsSearchClass"
import {AuthContext} from "../context/AuthContext"
import {getAuthHeader, getPathBack, setErrorWindow} from "../functions"
import {ModalWin} from "./ModalWin"
import {useNavigate} from "react-router-dom"

export const ViewWindowSearch = ({lang}) => {

    const l = lang.lang
    const [show, setShow] = useState(true)
    const {request} = useHttp()
    const auth = useContext(AuthContext)
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [resultSearch, setResultSearch] = useState({
        title: lang.messages.code_701,
        requestSearch: '',
        body: {
            folders: [],
            links: [],
            notes: [],
        },
        publicBody: {
            folders: [],
            links: [],
            notes: []
        },
        googleBody: {
           documents: {}
        },
        btnBack: 'Назад',
        loading: false
    })
    const navigate = useNavigate()

    let timerId

    const closeHandler = () => {
        setShow(false)
        navigate(getPathBack(), {replace: true})
        // window.location.replace(getPathBack())
    }

    const searchHandler = (e) => {

        clearTimeout(timerId)

        timerId = setTimeout(async () => {

            if (e.target.value === '') {
                return
            } else {
                setResultSearch({
                    title: '',
                    requestSearch: e.target.value,
                    body: {
                        folders: [],
                        links: [],
                        notes: []
                    },
                    publicBody: {
                        folders: [],
                        links: [],
                        notes: []
                    },
                    googleBody: {
                        documents: {
                            folders: [],
                            files: [],
                            path: []
                        }
                    },
                    btnBack: 'Назад',
                    loading: true
                })
            }

            let host
            window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
            let data = {
                founded_folders: [],
                founded_links: [],
                founded_notes: [],
                founded_folders_public: [],
                founded_links_public: [],
                founded_notes_public: [],
                founded_google_documents: {},
                searchingLang: '',
                searchingWord: ''
            }

            let headers = {}
            if (auth.userId) {
                headers = {
                    Authorization: getAuthHeader(auth)
                }
            }

            try {
                data = await request(
                    `${host}/api/search?query=${e.target.value}&usr=${auth.userId || ''}&auth-wia=${auth.authenticatedVia || 'no-authorization'}&google-parent-id=${'all'}&google-search-max-items=100&google-redirect-uri=${window.location.origin}`,
                    'GET',
                    null,
                    headers)

                if (data.status > 200) {
                    setAllowed(false)
                    setDataModal(setErrorWindow('', data.code))
                }

                if (data.searchingLang !== 'original') {
                    document.getElementById("navSearch").value = data.searchingWord
                }

                setResultSearch({
                    title: lang.messages[`code_${data.code}`],
                    requestSearch: e.target.value,
                    body: {
                        folders: data.founded_folders,
                        links: data.founded_links,
                        notes: data.founded_notes
                    },
                    publicBody: {
                        folders: data.founded_folders_public,
                        links: data.founded_links_public,
                        notes: data.founded_notes_public
                    },
                    googleBody: {
                        documents: data.founded_google_documents
                    },
                    btnBack: 'Назад',
                    loading: false
                })

            } catch (e) {
                window.location.replace(`/${l}/`)
            }
        }, 2000)
    }

    if (!allowed) {
        return <ModalWin data={dataModal}/>
    }

    return (
        <>
            <Modal id={"search-window"} show={show}>
                <Modal.Header>
                    <Modal.Title className={'w-100'}>
                        <input autoComplete={"off"}
                               id={"navSearch"}
                               className={"form-control me-1 ms-1"}
                               type={"search"}
                               placeholder={lang.navbar.isAuth.placeholderSearch}
                               aria-label={"Search"}
                               onChange={searchHandler}
                        />
                    </Modal.Title>
                    <Button className={'ms-2'}
                            variant={"close"}
                            onClick={closeHandler}>
                    </Button>
                </Modal.Header>

                <ViewResultsSearchClass data={resultSearch}/>

                <Modal.Footer>

                </Modal.Footer>
            </Modal>
        </>
    )
}